import { restoreSearchHistory } from './search-history/search-history.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { CarDetailsComponent } from './pages/car-details/car-details.component';
import { CarSearchComponent } from './pages/car-search/car-search.component';
import { DataProtectionComponent } from './pages/data-protection/data-protection.component';
import { DeleteAccount } from './pages/delete-account/delete-account';
import { FaqComponent } from './pages/faq/faq.component';
import { ForgetPasswordComponent } from './pages/forget-password/forget-password.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { PrivacySettingsComponent } from './pages/privacy-settings/privacy-settings.component';
import { PropertyDetailsComponent } from './pages/property-details/property-details.component';
import { PropertySearchComponent } from './pages/property-search/property-search.component';
import { RegisterComponent } from './pages/register/register.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { UpdatePasswordComponent } from './pages/update-password/update-password.component';
import { UserDetailsComponent } from './pages/user-details/user-details.component';
import { UsersComponent } from './pages/users/users.component';
import { Roles } from './shared/constants/role.constants';

const routes: Routes = [
  { path: 'blocked-agents', canActivate: [AuthGuard], loadComponent: () => import('./pages/blocked-agents/blocked-agents.page').then(m => m.BlockedAgentsPage) },
  { path: 'saved-searches/unsubscribe', loadComponent: () => import('./saved-searches/unsubscribe.page').then(m => m.UnsubscribePage) },
  { path: 'saved-searches', canActivate: [AuthGuard], loadComponent: () => import('./saved-searches/saved-searches.page').then(m => m.SavedSearchesPage) },
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'data-protection', component: DataProtectionComponent },
  { path: 'terms', component: TermsConditionsComponent },
  { path: 'privacy-settings', component: PrivacySettingsComponent },
  { path: 'account-deletion', component: DeleteAccount },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'cars/list', component: CarSearchComponent, canActivate: [restoreSearchHistory], runGuardsAndResolvers: 'always', data: { searchDomain: 'CAR', searchMode: 'list' } },
  { path: 'cars/map', component: CarSearchComponent, canActivate: [restoreSearchHistory], runGuardsAndResolvers: 'always', data: { searchDomain: 'CAR', searchMode: 'map' } },
  { path: 'cars', component: CarSearchComponent, canActivate: [restoreSearchHistory], runGuardsAndResolvers: 'always', data: { searchDomain: 'CAR' } },
  { path: 'cars/:id', component: CarDetailsComponent },
  { path: 'add-car/:id', loadChildren: () => import('./pages/add-car/add-car.module').then(m => m.AddCarModule), canActivate: [AuthGuard] },
  { path: 'properties/list', component: PropertySearchComponent, canActivate: [restoreSearchHistory], runGuardsAndResolvers: 'always', data: { searchDomain: 'REAL_ESTATE', searchMode: 'list' } },
  { path: 'properties/map', component: PropertySearchComponent, canActivate: [restoreSearchHistory], runGuardsAndResolvers: 'always', data: { searchDomain: 'REAL_ESTATE', searchMode: 'map' } },
  { path: 'properties', component: PropertySearchComponent, canActivate: [restoreSearchHistory], runGuardsAndResolvers: 'always', data: { searchDomain: 'REAL_ESTATE' } },
  { path: 'properties/:id', component: PropertyDetailsComponent },
  { path: 'add-property/:id', loadChildren: () => import('./pages/add-property/add-property.module').then(m => m.AddPropertyModule), canActivate: [AuthGuard] },
  { path: 'forgot-password', component: ForgetPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'update-password', component: UpdatePasswordComponent, canActivate: [AuthGuard] },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [RoleGuard],
    data: {
      roles: [Roles.Admin, Roles.Editor],
    },
  },
  {
    path: 'users',
    component: UsersComponent,
  },
  {
    path: 'users/:id',
    component: UserDetailsComponent,
  },
  { path: '**', redirectTo: '' }, // Wildcard: redirect to home
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      canceledNavigationResolution: 'computed',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
